import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { environment } from '../../../environments/environment';

interface NavLinkItem {
  type: 'link';
  label: string;
  icon: string;
  route: string;
}

interface NavSectionItem {
  type: 'section';
  label: string;
}

type NavItem = NavLinkItem | NavSectionItem;

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
  private readonly authService = inject(AuthService);

  readonly isSidebarCollapsed = signal(false);
  readonly username = computed(() => this.authService.username || 'Usuario');
  readonly logoUrl = 'assets/images/labanca_logo-scaled.png';
  readonly version = environment.version;
  readonly navItems: NavItem[] = [ 
    { type: 'section', label: 'eRaspadita' },
    { type: 'link', label: 'Dashboard', icon: 'dashboard', route: '/dashboard' },
    { type: 'link', label: 'Juegos', icon: 'sports_esports', route: '/games' },
    { type: 'link', label: 'Categorías', icon: 'folder', route: '/categories' },
    { type: 'link', label: 'Lobbys', icon: 'view_carousel', route: '/lobbys' },
    { type: 'link', label: 'Usuarios', icon: 'people', route: '/users' },
    { type: 'link', label: 'Importar', icon: 'sync', route: '/import' },
    { type: 'section', label: 'Raspaditas' },
    { type: 'link', label: 'Popup Juego Responsable', icon: 'health_and_safety', route: '/eraspadita-responsible-popup' },
    { type: 'link', label: 'Raspaditas Físicas', icon: 'casino', route: '/raspaditas-fisicas' },
    { type: 'link', label: 'Raspaditas Electrónicas', icon: 'smartphone', route: '/e-raspaditas' },
    { type: 'section', label: 'Institucional' },
    { type: 'link', label: 'Portadas', icon: 'image', route: '/covers' },
    { type: 'link', label: 'Noticias', icon: 'article', route: '/news' },
    { type: 'link', label: 'Categorías', icon: 'category', route: '/news-categories' },
    { type: 'link', label: 'Páginas Informativas', icon: 'description', route: '/informational-pages' },
    { type: 'link', label: 'Suscripciones email', icon: 'mark_email_read', route: '/email-result-subscriptions' },
    { type: 'link', label: 'Segunda Chance', icon: 'confirmation_number', route: '/segunda-chance' },
    { type: 'link', label: 'Lotería', icon: 'emoji_events', route: '/loteria' },
    { type: 'link', label: 'Pop-up promocional', icon: 'campaign', route: '/promotional-popups' },    
    { type: 'section', label: 'Red de Vendedores' },
    { type: 'link', label: 'Bancas', icon: 'storefront', route: '/bancas-vendedores' },
    { type: 'section', label: 'Sistema' },
    { type: 'link', label: 'Variables de entorno', icon: 'tune', route: '/config-environment' },
    { type: 'section', label: 'Streaming' },
    { type: 'link', label: 'Configuración', icon: 'live_tv', route: '/streaming-config' },
  ];

  toggleSidebar(): void {
    this.isSidebarCollapsed.update(v => !v);
  }

  getUserInitial(): string {
    return (this.username() || 'U').charAt(0).toUpperCase();
  }

  logout(): void {
    this.authService.logout();
  }
}
